/**
 * Compact relative-time formatter shared by the points activity log and the
 * aggregated "top earners" rows. Keys live in the `reputation` i18n
 * namespace under `points.log-time-*`.
 */
export type TFn = (key: string, values?: Record<string, string | number>) => string;

export function relTime(iso: string, t: TFn): string {
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 30) return t('points.log-time-just-now');
  if (diff < 60) return t('points.log-time-seconds-ago', { count: Math.floor(diff) });
  if (diff < 3600) return t('points.log-time-minutes-ago', { count: Math.floor(diff / 60) });
  if (diff < 3600 * 24) return t('points.log-time-hours-ago', { count: Math.floor(diff / 3600) });
  if (diff < 3600 * 48) return t('points.log-time-yesterday');
  if (diff < 3600 * 24 * 7) return t('points.log-time-days-ago', { count: Math.floor(diff / 3600 / 24) });
  if (diff < 3600 * 24 * 30) return t('points.log-time-weeks-ago', { count: Math.floor(diff / 3600 / 24 / 7) });
  return t('points.log-time-months-ago', { count: Math.floor(diff / 3600 / 24 / 30) });
}
